export default __webpack_public_path__ + "static/media/logo-light.89c62bc0.svg";